module.exports = __webpack_public_path__ + "static/media/image-not-available.d4af1343.jpg";